import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/appointment-scheduling-system/components/AppointmentSchedulingInteractive.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/common/Header.tsx");
